import { createBrowserRouter } from 'react-router'
import { AiConnectorPage } from '@/features/ai-connector/ai-connector-page'
import { AnnouncementEditorPage } from '@/features/announcements/announcement-editor-page'
import { AnnouncementsPage } from '@/features/announcements/announcements-page'
import { CampaignEditorPage } from '@/features/marketing/campaign-editor-page'
import { MarketingPage } from '@/features/marketing/marketing-page'
import { AuditLogPage } from '@/features/audit/audit-log-page'
import { AcceptInvitePage } from '@/features/auth/accept-invite-page'
import { SignInPage } from '@/features/auth/sign-in-page'
import { SalesPage } from '@/features/billing/sales-page'
import { SubscriptionsPage } from '@/features/billing/subscriptions-page'
import { CustomerPage } from '@/features/customers/customer-page'
import { CustomersPage } from '@/features/customers/customers-page'
import { DashboardPage } from '@/features/dashboard/dashboard-page'
import { AudiencePage } from '@/features/demographics/audience-page'
import { DiscountsPage } from '@/features/discounts/discounts-page'
import { EmailEditorPage } from '@/features/emails/email-editor-page'
import { EmailsPage } from '@/features/emails/emails-page'
import { ArticleEditorPage } from '@/features/help/article-editor-page'
import { HelpPage } from '@/features/help/help-page'
import { NotificationsPage } from '@/features/notifications/notifications-page'
import { LimitsPage } from '@/features/limits/limits-page'
import { ConnectionsPage } from '@/features/connections/connections-page'
import { WebsitePage } from '@/features/website/website-page'
import { ProfilePage } from '@/features/profile/profile-page'
import { ReferralsPage } from '@/features/referrals/referrals-page'
import { FeedbackPage } from '@/features/feedback/feedback-page'
import { ResearchProgramPage } from '@/features/research-program/research-program-page'
import { SettingsPage } from '@/features/settings/settings-page'
import { TeamPage } from '@/features/team/team-page'
import { HeldEmailsPage } from '@/features/tickets/held-emails-page'
import { ReplyTemplatesPage } from '@/features/tickets/reply-templates-page'
import { TicketsPage } from '@/features/tickets/inbox-page'
import { RouteErrorBoundary } from './fallbacks'
import { Layout } from './layout'

export const routes = [
  {
    // Crashes and unknown addresses anywhere below land here.
    errorElement: <RouteErrorBoundary />,
    children: [
      { path: '/sign-in', element: <SignInPage /> },
      { path: '/accept-invite', element: <AcceptInvitePage /> },
      {
        element: <Layout />,
        children: [
          { index: true, element: <DashboardPage /> },
          { path: 'tickets', element: <TicketsPage /> },
          { path: 'tickets/templates', element: <ReplyTemplatesPage /> },
          { path: 'tickets/held', element: <HeldEmailsPage /> },
          { path: 'tickets/:ticketId', element: <TicketsPage /> },
          { path: 'customers', element: <CustomersPage /> },
          { path: 'customers/:customerId', element: <CustomerPage /> },
          { path: 'audience', element: <AudiencePage /> },
          { path: 'website', element: <WebsitePage /> },
          { path: 'ai-connector', element: <AiConnectorPage /> },
          { path: 'sales', element: <SalesPage /> },
          { path: 'subscriptions', element: <SubscriptionsPage /> },
          { path: 'discounts', element: <DiscountsPage /> },
          { path: 'referrals', element: <ReferralsPage /> },
          { path: 'feedback', element: <FeedbackPage /> },
          { path: 'research-program', element: <ResearchProgramPage /> },
          { path: 'emails', element: <EmailsPage /> },
          { path: 'announcements', element: <AnnouncementsPage /> },
          { path: 'announcements/new', element: <AnnouncementEditorPage /> },
          { path: 'announcements/:announcementId', element: <AnnouncementEditorPage /> },
          { path: 'marketing', element: <MarketingPage /> },
          { path: 'marketing/new', element: <CampaignEditorPage /> },
          { path: 'marketing/:campaignId', element: <CampaignEditorPage /> },
          { path: 'emails/new', element: <EmailEditorPage /> },
          { path: 'emails/:emailId', element: <EmailEditorPage /> },
          { path: 'help', element: <HelpPage /> },
          { path: 'help/new', element: <ArticleEditorPage /> },
          { path: 'help/:articleId', element: <ArticleEditorPage /> },
          { path: 'notifications', element: <NotificationsPage /> },
          { path: 'settings', element: <SettingsPage /> },
          { path: 'audit-log', element: <AuditLogPage /> },
          { path: 'team', element: <TeamPage /> },
          { path: 'profile', element: <ProfilePage /> },
          { path: 'limits', element: <LimitsPage /> },
          { path: 'connections', element: <ConnectionsPage /> },
        ],
      },
    ],
  },
]

export const router = createBrowserRouter(routes)
